import ConfirmDetails from './ConfirmDetails.component';

export default ConfirmDetails;
